import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SectionProps {
  id?: string;
  className?: string;
  children: ReactNode;
  /** Vertical rhythm. */
  spacing?: "default" | "compact" | "loose";
}

const spacings: Record<NonNullable<SectionProps["spacing"]>, string> = {
  // compact: "py-16 sm:py-20",
  // default: "py-20 sm:py-28 lg:py-32",
  compact: "py-12 sm:py-16",
  default: "py-16 sm:py-20 lg:py-24",
  loose: "py-24 sm:py-32 lg:py-40",
};

/** Semantic vertical section with consistent spacing. */
export function Section({
  id,
  className,
  children,
  spacing = "default",
}: SectionProps) {
  return (
    <section id={id} className={cn(spacings[spacing], className)}>
      {children}
    </section>
  );
}
